/**
 * "My scheduled" in Chats (05-10-2026, Jordy): je EIGEN geplande Mass DM's
 * zien en annuleren, niet die van anderen. Smal, los van de Overview van de
 * Mass Messages-pagina (die blijft dicht voor chatters). Server:
 * `mass-message/mine` en `mass-message/mine/{id}/cancel`.
 *
 * 06-10-2026 (Jordy): ook je eigen MISLUKTE Mass DM's (14 dagen), met
 * "Retry…" (Retry now / Retry at…) via `mass-message/mine/{id}/retry`.
 *
 * 07-10-2026 (Jordy): tijden in de tijdzone van de gebruiker, met de zone erbij.
 */
import { useState } from 'react'
import { Modal } from './Modal'
import { Empty, ErrorNote, Loading, Tag } from './ui'
import { useApi } from '../lib/useApi'
import { mut, useActions } from '../lib/actions'
import { metZone, zoneLabel } from '../lib/amsterdam'
import { useMijnZone } from '../lib/tijdzone'
import { RetryMassaDialoog } from './RetryMassaDialoog'

interface Eigen {
  id: number
  model_name?: string | null
  model_slug?: string | null
  platform?: string | null
  content?: string | null
  scheduled_at: string
  status?: string | null
  error_message?: string | null
  only_test?: boolean | null
}

const BASIS = '/api/admin/conversations/mass-message/mine'

export function MijnGeplandeMassDm({ onClose }: { onClose: () => void }) {
  const q = useApi<{ items: Eigen[] }>('/api/admin/conversations/mass-message/mine')
  const { run, busy } = useActions()
  const items = q.data?.items ?? []
  const [retry, setRetry] = useState<Eigen | null>(null)
  const zone = useMijnZone()
  if (retry) {
    return (
      <RetryMassaDialoog basis={BASIS} id={retry.id} echteFans={!retry.only_test} zone={zone}
                         onClose={() => setRetry(null)} onKlaar={q.refetch} />
    )
  }
  return (
    <Modal title="My scheduled Mass DMs" width={620} onClose={onClose}
           desc={`Only the Mass DMs you scheduled yourself that have not gone out yet, and your failed ones of the last 14 days. Times are ${zoneLabel(zone)} time.`}>
      {q.loading && !q.data ? <Loading /> : null}
      {q.error ? <ErrorNote error={q.error} /> : null}
      {q.data && !items.length ? <Empty>Nothing scheduled.</Empty> : null}
      {items.map((it) => (
        <div key={it.id} className="card row" style={{ gap: 10, marginBottom: 8, alignItems: 'flex-start' }}
             data-testid="mijn-gepland">
          <div style={{ flex: 1, minWidth: 0 }}>
            <b>{it.model_name || it.model_slug}</b>
            <span className="mut2"> · {String(it.platform ?? '').toUpperCase()} · {metZone(it.scheduled_at, zone)}</span>
            {it.status === 'failed' ? <> <Tag kind="bad">failed</Tag></> : null}
            {it.status === 'failed' && it.error_message ? (
              <div className="mut2" style={{ fontSize: 12, marginTop: 2 }}>Reason: {it.error_message}</div>
            ) : null}
            <div className="mut2" style={{ fontSize: 12.5, marginTop: 4, overflowWrap: 'anywhere' }}>
              {(it.content ?? '').slice(0, 160)}
            </div>
          </div>
          {it.status === 'failed' ? (
            <button className="btn sm" type="button" data-testid="mijn-retry" onClick={() => setRetry(it)}>
              Retry…
            </button>
          ) : (
          <button className="btn ghost sm" type="button" disabled={busy !== null}
                  onClick={() => run({
                    label: 'Cancel scheduled Mass DM',
                    confirm: `Cancel the Mass DM on ${metZone(it.scheduled_at, zone)}? Nothing will be sent.`,
                    request: mut.post(`/api/admin/conversations/mass-message/mine/${it.id}/cancel`, {}),
                    onDone: q.refetch,
                    successText: 'Scheduled Mass DM cancelled.',
                  })}>
            Cancel
          </button>
          )}
        </div>
      ))}
    </Modal>
  )
}
